module.exports = __webpack_public_path__ + "img/national-qualification-level-3.74915b72.jpg";